import React, { Component, Fragment } from 'react'
import Grid from '@material-ui/core/Grid'
import { withStyles } from '@material-ui/core/styles'
import PropTypes from 'prop-types'
import gql from 'graphql-tag'
import { Query, ApolloConsumer } from 'react-apollo'
import { Typography } from '@material-ui/core'
import Button from '@material-ui/core/Button'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import Select from 'react-select'
import CustomerDetailsCard from '../../Modules/CustomerDetailsCard'
import SubscriptionDetails from './subscriptionDetails'
import withSharedSnackbar from '../../HOCs/withSharedSnackbar'
import getLoginId from '../../../utils/getLoginId'
import Loader from '../../../components/common/Loader'
import ConfirmationalDialog from '../../common/ConfirmationDialog'

const GET_CLIENTS = gql`
  query allClientDetails($partnerLoginId: Int) {
    clients: allClientDetails(partnerLoginId: $partnerLoginId) {
      id
      clientName
      loginId
    }
  }
`

const GET_CLIENT = gql`
  query clientDetail($id: Int) {
    clientDetail(loginId: $id) {
      id
      clientName
      contactPerson
      address
      city
      state {
        zone_id
        name
      }
      country {
        country_id
        name
      }
      email
      contactNumber
      login {
        username
      }
      pincode
      panNumber
      status
      type
    }
  }
`
const UPDATE_SUBSCRIPTION = gql`
  mutation updateSubscriptions(
    $id: Int!
    $clientLoginId: Int!
    $partnerLoginId: Int!
    $billingFrequencyId: Int!
    $deviceQuantity: Int!
    $softwareQuantity: Int!
    $accessoryQuantity: Int
    $simQuantity: Int
  ) {
    updateSubscriptions(
      id: $id
      clientLoginId: $clientLoginId
      partnerLoginId: $partnerLoginId
      billingFrequencyId: $billingFrequencyId
      deviceQuantity: $deviceQuantity
      softwareQuantity: $softwareQuantity
      accessoryQuantity: $accessoryQuantity
      simQuantity: $simQuantity
    )
  }
`

const GET_SUBSCRIPTION_DETAIL = gql`
  query getSubscriptions($subscriptionId: Int) {
    getSubscriptions(id: $subscriptionId) {
      id
      status
      client {
        loginId
        clientName
      }
      billingMode {
        id
        billingMode
      }
      billingFrequency {
        id
        frequency
      }
      plan
      amount
      createdAt
      nextPaymentDate
      unAssignedDeviceQuantity
      unAssignedAccessoryQuantity
      unAssignedSimQuantity
      minimumAmountDue
      salesRemarks
      invoiceDownloadLink
      deviceModel {
        model_name
      }
      accessoryType {
        accessoryName
      }
      serviceProvider {
        name
      }
      billingDetails {
        paymentId
        totalAmount
        totalAmountWithGST
        softwareBill {
          quantity
          rate
          amountWithGST
        }
        hardwareBill {
          quantity
          rate
          amountWithGST
        }
        accessoryBill {
          quantity
          rate
          amountWithGST
        }
        simBill {
          quantity
          rate
          amountWithGST
        }
      }
    }
  }
`

const style = theme => ({
  root: {
    padding: theme.spacing.unit * 4,
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing.unit * 2
    },
    flexGrow: 1
  },
  input: {
    display: 'flex',
    padding: 0
  }
})

function ClientSelected(props) {
  const isClientSelected = props.isClientSelected
  if (isClientSelected) {
    return (
      <Grid container spacing={16}>
        <Grid item xs={12}>
          <CustomerDetailsCard clientDetail={props.clientDetails} />
        </Grid>
      </Grid>
    )
  }
  return null
}

function ShowSubDetails(props) {
  const isClientSelected = props.isClientSelected
  return (
    <Fragment>
      <ConfirmationalDialog
        isDialogOpen={props.isUpdateConfDialogOpen}
        dialogMessage={'Are you sure you want to Update this subscription?'}
        negativeResponseHandler={props.updateNegativeResponseHandler}
        positiveResponseHandler={props.updatePositiveResponseHandler}
        isSaveBtnDisabled={props.isSaveBtnDisabled}
      />
      <ConfirmationalDialog
        isDialogOpen={props.isCancelConfDialogOpen}
        dialogMessage={'Are you sure you want to Cancel the changes?'}
        negativeResponseHandler={props.cancelNegativeResponseHandler}
        positiveResponseHandler={props.cancelPositiveResponseHandler}
      />
      {isClientSelected && (
        <SubscriptionDetails
          subscriptionData={props.subscriptionData}
          isClientSelected={props.isClientSelected}
          billingFrequencyId={props.billingFrequencyId}
          nextPaymentDate={props.nextPaymentDate}
          totalQuantity={props.totalQuantity}
          deviceQuantity={props.deviceQuantity}
          accessoryQuantity={props.accessoryQuantity}
          simQuantity={props.simQuantity}
          softwareQuantity={props.softwareQuantity}
          deviceTotalAmount={props.deviceTotalAmount}
          softwareTotalAmount={props.softwareTotalAmount}
          accessoryTotalAmount={props.accessoryTotalAmount}
          simTotalAmount={props.simTotalAmount}
          handleSelectChange={props.handleSelectChange}
          handleSelectDayChange={props.handleSelectDayChange}
          handleSelectGstChange={props.handleSelectGstChange}
          handleChange={props.handleChange}
          handleSelectBillingModeChange={props.handleSelectBillingModeChange}
          handleCancelClick={props.handleCancelClick}
          handleUpdateClick={props.handleUpdateClick}
        />
      )}
    </Fragment>
  )
}

class EditSubscription extends Component {
  constructor(props) {
    super(props)

    this.subscriptionId = this.props.match.params.subscriptionId
    this.loginId = this.props.match.params.loginId
    this.state = {
      clientId: null,
      subscriptionData: null,
      isUpdateConfDialogOpen: false,
      isCancelConfDialogOpen: false,
      isSaveBtnDisabled: false,
      clientDetails: null,
      isClientSelected: false,
      billingFrequencyId: null,
      nextPaymentDate: null,
      totalQuantity: null,
      deviceQuantity: 0,
      softwareQuantity: 0,
      accessoryQuantity: 0,
      simQuantity: 0,
      deviceTotalAmount: 0,
      softwareTotalAmount: 0,
      accessoryTotalAmount: 0,
      simTotalAmount: 0,
      grandTotalAmount: null,
      isStateChanged: false,
      initStatus: {
        deviceQuantity: 0,
        accessoryQuantity: 0,
        simQuantity: 0,
        softwareQuantity: 0
      }
    }
  }

  handleChange = name => event => {
    this.setState({
      isStateChanged: true
    })
    console.log('change values')
    const {
      billingDetails: { softwareBill, hardwareBill, accessoryBill, simBill }
    } = this.state.subscriptionData
    if (
      !(event.target.value < this.state.initStatus[name]) &&
      event.target.value >= 0
    ) {
      console.log(name)
      if (name === 'softwareQuantity') {
        let total = event.target.value * softwareBill.rate
        this.setState({
          softwareTotalAmount: total,
          softwareQuantity: event.target.value
        })
      } else if (name === 'deviceQuantity') {
        console.log(event.target.value)
        let total = event.target.value * hardwareBill.rate
        this.setState({
          deviceTotalAmount: total,
          [name]: event.target.value
        })
      } else if (name === 'accessoryQuantity') {
        let total = event.target.value * accessoryBill.rate
        this.setState({
          accessoryTotalAmount: total,
          [name]: event.target.value
        })
      } else if (name === 'simQuantity') {
        let total = event.target.value * simBill.rate
        this.setState({
          simTotalAmount: total,
          [name]: event.target.value
        })
      }
    }
  }

  handleCancelClick = e => {
    if (this.state.isStateChanged) {
      this.setState({ isCancelConfDialogOpen: true })
    } else {
      this.handleCancelSubscription()
    }
  }

  handleUpdateClick = e => {
    this.setState({ isUpdateConfDialogOpen: true })
  }

  handleCancelNegativeResponse = e => {
    this.setState({ isCancelConfDialogOpen: false })
  }

  handleUpdateNegativeResponse = e => {
    this.setState({ isSaveBtnDisabled: false })
    this.setState({ isUpdateConfDialogOpen: false })
  }

  handleCancelSubscription = e => {
    this.props.history.goBack()
  }

  handleUpdateSubscription = async event => {
    this.setState({ isSaveBtnDisabled: true })
    if (
      parseInt(this.state.deviceQuantity, 10) !==
      parseInt(this.state.softwareQuantity, 10)
    ) {
      this.props.openSnackbar(
        'Device total quantity and device quantity should be equal'
      )
    } else {
      const { data, errors } = await this.props.client.mutate({
        mutation: UPDATE_SUBSCRIPTION,
        variables: {
          id: parseInt(this.subscriptionId, 10),
          clientLoginId: parseInt(this.loginId, 10),
          partnerLoginId: getLoginId(),
          billingFrequencyId: parseInt(this.state.billingFrequencyId, 10),
          deviceQuantity: parseInt(this.state.deviceQuantity, 10),
          softwareQuantity: parseInt(this.state.softwareQuantity, 10),
          accessoryQuantity: parseInt(this.state.accessoryQuantity, 10),
          simQuantity: parseInt(this.state.simQuantity, 10)
        },
        errorPolicy: 'all'
      })
      if (errors) {
        this.props.openSnackbar(errors[0].message, { type: 'error' })
      } else if (data.updateSubscriptions === true) {
        this.props.openSnackbar('Subscription Updation Successful')
        this.props.history.push({
          pathname: '/home/subscriptions/'
        })
      }
      // if (data === true && data.updateSubscriptions === true) {
      //   this.props.openSnackbar('Subscription Updation Successful')
      //   this.props.history.push({
      //     pathname: '/home/subscriptions/'
      //   })
      // } else if (errors) {
      //   this.props.openSnackbar(errors[0].message, { type: 'error' })
      // }
    }
  }

  componentDidMount() {
    this.getAllDetails()
  }

  getAllDetails = async () => {
    let initStatus = {
      deviceQuantity: 0,
      accessoryQuantity: 0,
      simQuantity: 0,
      softwareQuantity: 0
    }

    const clientDetails = await this.props.client.query({
      query: GET_CLIENT,
      variables: {
        id: parseInt(this.loginId, 10)
      },
      fetchPolicy: 'network-only'
    })

    const fetchedSubscriptionData = await this.props.client.query({
      query: GET_SUBSCRIPTION_DETAIL,
      variables: {
        subscriptionId: parseInt(this.subscriptionId, 10)
      },
      fetchPolicy: 'network-only'
    })

    const { getSubscriptions } = fetchedSubscriptionData.data
    this.setState({ subscriptionData: getSubscriptions })
    console.log('Edit subscription data:', fetchedSubscriptionData)

    // Maintain initial settings
    if (getSubscriptions.billingDetails) {
      const {
        billingDetails: { softwareBill, hardwareBill, accessoryBill, simBill }
      } = getSubscriptions
      if (hardwareBill) {
        initStatus['deviceQuantity'] = hardwareBill.quantity
        this.setState({
          deviceQuantity: hardwareBill.quantity,
          deviceTotalAmount: hardwareBill.quantity * hardwareBill.rate
        })
      }
      if (softwareBill) {
        initStatus['softwareQuantity'] = softwareBill.quantity
        this.setState({
          softwareQuantity: softwareBill.quantity,
          softwareTotalAmount: softwareBill.quantity * softwareBill.rate
        })
      }
      if (accessoryBill) {
        initStatus['accessoryQuantity'] = accessoryBill.quantity
        this.setState({
          accessoryQuantity: accessoryBill.quantity,
          accessoryTotalAmount: accessoryBill.quantity * accessoryBill.rate
        })
      }
      if (simBill) {
        initStatus['simQuantity'] = simBill.quantity
        this.setState({
          simQuantity: simBill.quantity,
          simTotalAmount: simBill.quantity * simBill.rate
        })
      }
    }

    // Take care of non mandatory fields
    // TODO: Explore handling this in the query
    // console.log(fetchedSubscriptionData.data.getSubscriptions.nextPaymentDate, 'nextpay')
    var fields = {
      initStatus: initStatus,
      clientDetails: clientDetails.data.clientDetail,
      clientId: this.loginId,
      isClientSelected: true,
      billingFrequencyId:
        fetchedSubscriptionData.data.getSubscriptions.billingFrequency.id
    }
    this.setState(fields)
  }

  render() {
    const { classes } = this.props
    return (
      <Query
        query={GET_CLIENTS}
        variables={{
          partnerLoginId: getLoginId()
        }}
        fetchPolicy="network-only"
      >
        {({ loading, error, data: { clients } }) => {
          if (loading) return <Loader />
          if (error) return `Error!: ${error}`

          const allClients = clients.map(client => ({
            value: client.loginId,
            label: client.clientName
          }))

          return (
            <div className={classes.root}>
              <Grid container spacing={16} direction="row">
                <Grid item>
                  <Button
                    variant="outlined"
                    color="secondary"
                    className={classes.button}
                    onClick={this.handleCancelClick}
                  >
                    <ArrowBackIcon className={classes.iconSmall} />
                  </Button>
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="headline">Edit Subscription</Typography>
                </Grid>
                <Grid item xs={6}>
                  <Select
                    classes={classes}
                    options={allClients}
                    value={this.state.clientId}
                    disabled
                  />
                </Grid>
                <Grid item container spacing={16} direction="row">
                  <Grid item xs={12}>
                    <ClientSelected
                      isClientSelected={this.state.isClientSelected}
                      clientDetails={this.state.clientDetails}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <ShowSubDetails
                      isSaveBtnDisabled={this.state.isSaveBtnDisabled}
                      subscriptionData={this.state.subscriptionData}
                      isClientSelected={this.state.isClientSelected}
                      isUpdateConfDialogOpen={this.state.isUpdateConfDialogOpen}
                      isCancelConfDialogOpen={this.state.isCancelConfDialogOpen}
                      billingFrequencyId={this.state.billingFrequencyId}
                      totalQuantity={this.state.totalQuantity}
                      deviceQuantity={this.state.deviceQuantity}
                      accessoryQuantity={this.state.accessoryQuantity}
                      simQuantity={this.state.simQuantity}
                      softwareQuantity={this.state.softwareQuantity}
                      deviceTotalAmount={this.state.deviceTotalAmount}
                      softwareTotalAmount={this.state.softwareTotalAmount}
                      accessoryTotalAmount={this.state.accessoryTotalAmount}
                      simTotalAmount={this.state.simTotalAmount}
                      handleChange={this.handleChange}
                      handleCancelSubscription={this.handleCancelSubscription}
                      handleUpdateSubscription={this.handleUpdateSubscription}
                      handleCancelClick={this.handleCancelClick}
                      handleUpdateClick={this.handleUpdateClick}
                      cancelNegativeResponseHandler={
                        this.handleCancelNegativeResponse
                      }
                      updateNegativeResponseHandler={
                        this.handleUpdateNegativeResponse
                      }
                      cancelPositiveResponseHandler={
                        this.handleCancelSubscription
                      }
                      updatePositiveResponseHandler={
                        this.handleUpdateSubscription
                      }
                    />
                  </Grid>
                </Grid>
              </Grid>
            </div>
          )
        }}
      </Query>
    )
  }
}
EditSubscription.propTypes = {
  classes: PropTypes.object.isRequired
}

const withApolloClient = Component => props => (
  <ApolloConsumer>
    {client => <Component client={client} {...props} />}
  </ApolloConsumer>
)

export default withStyles(style)(
  withApolloClient(withSharedSnackbar(EditSubscription))
)



// WEBPACK FOOTER //
// ./src/components/Pages/EditSubscription/index.jsx